import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";

import IconHome from './svg/IconHome';
import { updateStoreHistory, resetTabBar } from "../../../actions/index";

function ButtonHome({ className, style }) {
  const globalHistory = useHistory();
  const dispatch = useDispatch();
  const onClick = () => {
    globalHistory.push('/home');
    dispatch(updateStoreHistory('/home'));
    dispatch(resetTabBar());
  }
  return (
    <div onClick={onClick} className={`button-home ${className}`} style={{...style, marginTop: -1, cursor: 'pointer'}}>
      <IconHome />
    </div>
  )
}

ButtonHome.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
}

export default ButtonHome;
